import Base from './Base';

class StripePayments extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'stripe';
        this.enableCoolDown = true;
    }

    createOxxo = ( data ) => {
        return  fetch(this.getUrlEndpoint("create-oxxo"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

    createSubscription = ( data ) => {
        return  fetch(this.getUrlEndpoint("subscribe"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

    cancelSubscription( user_id) {
        return fetch(this.getUrlEndpoint("cancel-subscription/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    editSubscription( data) {
        return fetch(this.getUrlEndpoint("edit-subscription"),{
            method: 'PATCH',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

    getSubscription( user_id) {
        return fetch(this.getUrlEndpoint("retrive-subscription/"+user_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }
    
}

export default StripePayments;